import servise from '@/router/axios'

export const addChannel = (data) => {
  return servise({
    url: '/account/channel/add',
    method: 'post',
    data
  })
}

export const updateChannel = (data) => {
  return servise({
    url: '/account/channel/update',
    method: 'PUT',
    data
  })
}

export const isAllShow = (params) => {
  return servise({
    url: '/slot/channel/report/data/all/show',
    method: 'get',
    params
  })
}

export const getSubjectInfo = (params) => {
  return servise({
    url: '/subjectInfo/get/subject',
    method: 'get',
    params
  })
}

export const getChannelSubjectList = (params) => {
  return servise({
    url:'/subjectInfo/get/slot/channel/name',
    params
  })
}